<template>
  <div class="table-action-wrapper d-flex flex-wrap align-items-center design-review" ref="container">
    <p class="item-selected m-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></p>
    <a @click.prevent="openPrintModal" href="#" class="btn btn-outline-success d-flex align-items-center ml-2" :class="{ disabled: Object.keys(ids).length === 0 }">
      <span>Print Artwork</span>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: null,
      ids: {}
    }
  },
  mounted() {
    let listStatus = this.store.getter('extra_attributes.status', {})

    for (const [key, value] of Object.entries(listStatus)) {
      if (value.step && value.step.includes('print_artwork')) {
        this.status = key
        this.store.commit('query.status', {
          value: key,
          valueLabel: value.text,
          fieldLabel: 'Status'
        })
        break
      }
    }

    // this.store.commit('more.blueprint', true)
    this.store.commit('cols.cb.hidden', false)
    this.$emit('change-filters', { search: '' }, { refresh: true, goToFirst: true })
    this.$emitter.on('table-list.refreshed', this.tableListRefreshed)
    this.$emitter.on('table-list.cb-changed', this.changeCb)
  },
  unmounted() {
    // this.store.commit('more.blueprint', false)
    this.store.commit('query.status', null)
    this.store.commit('cols.cb.hidden', true)
    this.$emitter.off('table-list.refreshed', this.tableListRefreshed)
    this.$emitter.off('table-list.cb-changed', this.changeCb)
  },
  computed: {
    store() {
      return this.config?.store
    },
    rows() {
      let rows = {}
      Object.entries(this.store.getter('rows', {})).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    }
  },
  methods: {
    changeCb({ cb }) {
      Object.entries(cb).forEach(([id, checked]) => {
        if (checked) {
          this.ids[id] = true
        } else if (this.ids[id] != undefined) {
          delete this.ids[id]
        }
      })
    },
    tableListRefreshed(e) {
      Object.entries(this.ids).forEach(([id]) => {
        e.cb[id] = false
        delete this.ids[id]
      })
    },
    openPrintModal() {
      if (Object.keys(this.ids).length === 0) return
      this.$emitter.emit('Modal', {
        name: 'manufacture.print-artwork',
        items: this.getSelectedItems(),
        options: {
          status: this.status,
          statuses: this.store.getter('extra_attributes.status', {})
        }
      })
    },
    getSelectedItems() {
      let items = {}
      Object.entries(this.ids).forEach(([id, item]) => {
        items[id] = {
          name: item?.name || id,
          artworks: {
            front: this.rows?.[id]?.manufacture?.design_artworks?.front || '',
            back: this.rows?.[id]?.manufacture?.design_artworks?.back || '',
            cut: this.rows?.[id]?.manufacture?.design_artworks?.cut || ''
          }
        }

        if (items[id].artworks.front || items[id].artworks.back || items[id].artworks.cut) {
          if (this.rows?.[id]?.manufacture?.refer_order) {
            items[id].order = _.cloneDeep(this.rows?.[id]?.manufacture?.refer_order)
            items[id].order.manufacturer = this.rows?.[id]?.manufacture?.manufacturer?.user_name
            items[id].order.line_items = _.filter(items[id].order.line_items, (item) => {
              return this.rows?.[id]?.manufacture?.product_identify == item.identify
            })
          }
        }
      })
      return items
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-action-wrapper.design-review {
  .item-selected {
    width: 140px;
  }
  .input-group {
    a {
      width: 100%;
      &:hover {
        background: #d1eeff;
      }
    }
  }
}
</style>
